import { auth, db } from '../../firebase'
import axios from 'axios'
import swal from 'sweetalert'


const generatePassword = () => {
    var pass = '';
    var str = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ' + 
            'abcdefghijklmnopqrstuvwxyz0123456789@#$';
      
    for (let i = 1; i <= 8; i++) {
        var char = Math.floor(Math.random()
                    * str.length + 1);
          
        pass += str.charAt(char)
    }
    return pass;
}

const mailer = (email, subject, action, remarks) => {
    if(action === 'approve') {
        const password = generatePassword()
        sendNotification(email, subject, approveTemplate(email, password))
            .then(res => {
                swal("Approved", "Email sent successfully", "success")
                db.collection('users').doc(email).update({
                    "isApproved": true
                })
                auth.createUserWithEmailAndPassword(email, password)
            })
            .catch(err => swal("Oops", "Something went wrong", "error"))
    }

    if(action === 'register') {
      sendNotification(email, subject, registerTemplate())
    }

    if(action === 'reject') {
      sendNotification(email, subject, rejectTemplate(remarks))
    }
}

const sendNotification = (email, subject, template) => {
    const dataObj = {
      emailFrom: process.env.REACT_APP_EMAIL,
      password: process.env.REACT_APP_PASSWORD,
      nameFrom: 'Corporate Secretarial Team',
      subject: subject,
      emailTo: email,
      html: template
    }
  
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: process.env.REACT_APP_EMAIL_NOTIFICATION_API,
        data: dataObj,
        headers: {
          apiKey: process.env.REACT_APP_MAIL_API_KEY
        }
      })
        .then(response => {
          const { data } = response
          if (data.message === 'Email sent successfully') {
            resolve(true)
          }
        })
        .catch(err => {
          console.log('error', err)
          reject(err)
        })
    })
}

const approveTemplate = (email, password) => {
return `<!Doctype html>
    <head>
    </head>
    <body>
        <p>Good day, </p>
        <p>
            Your registration has been validated. To cast your vote in all the matters included in the agenda of Megawide Construction Corporation’s 2021 Special Stockholders’ Meeting, please log in to <a href='${window.location.protocol}//${window.location.host}/'>${window.location.protocol}//${window.location.host}</a> using the following details: 
        </p>
        <p>
            <b>Username:</b> ${email}<br />
            <b>Password:</b> ${password} <br />
        </p>
        <p>Please note that you shall be allowed to vote <b>until 11:59 P.M. of 02 May 2021</b>.</p>
        <p>
            If you need assistance, you may contact us through this email:\n<a href="mailto:corporatesecretary@megawide.com.ph">corporatesecretary@megawide.com.ph</a>.
        </p>
        <p>Thank you and best regards,</p>
        <p>Corporate Secretarial Team</a>
    </body>
    </html>`
}

const registerTemplate = () => {
  return `<!Doctype html>
      <head>
      </head>
      <body>
          <p>Good day, </p>
          <p>
              New registration has been posted. To validate, please log in to <a href='${window.location.protocol}//${window.location.host}/'>${window.location.protocol}//${window.location.host}</a>.
          </p>
          <p>Please note that you shall be allowed to validate registrations <b>until 2:00 P.M. of 02 May 2021</b>.</p>
          <p>
              If you need assistance, you may contact us through this email:\n<a href="mailto:corporatesecretary@megawide.com.ph">corporatesecretary@megawide.com.ph</a>.
          </p>
          <p>Thank you and best regards,</p>
          <p>Corporate Secretarial Team</a>
      </body>
      </html>`
}

const rejectTemplate = (remarks) => {
  return `<!Doctype html>
      <head>
      </head>
      <body>
          <p>Good day, </p>
          <p>Thank you for your interest in participating in Megawide Construction Corporation’s (the “Company”) 2021 Special Stockholders’ Meeting (“2021 SSM”). </p>
          <p>After reviewing your registration details, we regret to inform you that the same was <b>REJECTED</b> due to the reason provided below:</p>
          <p><b>${remarks}</b></p>
          <p>If you wish to resubmit your registration details, please log in to <a href='${window.location.protocol}//${window.location.host}/'>${window.location.protocol}//${window.location.host}</a>. If you need assistance, please email the Company’s stock transfer agent at mpbiag@stocktransfer.com.ph and/or the Corporate Secretary at corporatesecretary@megawide.com.ph. </p>
          <p>You may still attend the 2021 SSM on 11 May 2021, at 2:00 P.M., through the following link: <a href="">Megawide 2021 SSM</a>. The 2021 SSM shall be broadcasted live via Microsoft Teams, which may be accessed either through a web browser or the Microsoft Teams application. </p>
          <p>Thank you and best regards,</p>
          <p>Corporate Secretarial Team</a>
      </body>
      </html>`
}

export {
    mailer
}